import { useEffect, useRef } from 'react'

/** 컨테이너의 자식이 화면에 들어오면 data-in="true", 나가면 "false". 연출은 CSS 쪽에서.
 *  스크롤을 오르내릴 때마다 다시 재생된다.
 *
 *  숨김 상태는 마크업의 data-reveal 속성으로 첫 페인트부터 걸려 있어야 한다.
 *  훅에서 붙이면 '보였다 → 사라졌다 → 다시 나옴'으로 한 번 깜빡인다.
 *  모션 최소화 설정일 때 안 숨는 것은 CSS의 prefers-reduced-motion이 책임진다. */
export default function useReveal<T extends HTMLElement>() {
  const ref = useRef<T>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const kids = Array.from(el.children) as HTMLElement[]

    // 애니메이션을 끈 사용자에게는 연출 없이 바로 보여준다
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return

    // 계속 관찰한다 — 화면 밖으로 나가면 다시 숨어서, 오르내릴 때마다 연출이 반복된다
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          ;(e.target as HTMLElement).dataset.in = e.isIntersecting ? 'true' : 'false'
        }),
      { rootMargin: '0px 0px -12% 0px' },
    )
    kids.forEach((k) => io.observe(k))
    return () => io.disconnect()
  }, [])

  return ref
}
